import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1.75),
    },
  }),
  { name: 'MenuContentImage' }
);
